const _themes = {
  aunity: {
    logo: '/static/images/NHS.png',
    altText: 'nhs logo',
    stylesheet: '/static/nhs.css'
  },
  axa: {
    logo: 'https://assets.hbsuk.co.uk/img/platform/HBSUK_Logo_Colour_RGB.svg',
    altText: 'hbsuk logo',
    stylesheet: '/static/hbsuk.css'
  },
  bob: {
    logo: '/static/images/NHS.png',
    altText: 'nhs logo',
    stylesheet: '/static/nhs.css'
  },
  dcg: {
    logo: '/static/images/LDC.png',
    altText: 'ldc logo',
    stylesheet: '/static/ldc.css'
  },
  demo: {
    logo: '/static/images/NHS.png',
    altText: 'nhs logo',
    stylesheet: '/static/nhs.css'
  },
  hbs: {
    logo: 'https://assets.hbsuk.co.uk/img/platform/HBSUK_Logo_Colour_RGB.svg',
    altText: 'hbsuk logo',
    stylesheet: '/static/hbsuk.css'
  },
  hbsgast: {
    logo: 'https://assets.hbsuk.co.uk/img/platform/HBSUK_Logo_Colour_RGB.svg',
    altText: 'hbsuk logo',
    stylesheet: '/static/hbsuk.css'
  },
  medway: {
    logo: '/static/images/NHS.png',
    altText: 'nhs logo',
    stylesheet: '/static/nhs.css'
  },
  helena: {
    logo: '/static/images/STH.png',
    altText: 'sth logo',
    stylesheet: '/static/sth.css'
  },
  blank: {
    logo: '/static/images/Blank.png',
    altText: 'blank logo',
    stylesheet: '/static/blank.css'
  }
} as const;

type Themes = {
  [K in keyof typeof _themes]: {
    id: K;
    logo?: string;
    altText?: string;
    stylesheet: string;
  };
};

export default Array.from(Object.entries(_themes)).reduce((acc, [key, value]) => {
  acc[key] = {
    id: key,
    ...value
  };
  return acc;
}, {} as Themes);
